module.exports = __webpack_public_path__ + "static/media/32 Cards.16baa651.jpg";